import React, { Component } from "react";
import { connect } from "react-redux";
import SecondaryEnvelopeForm from "./SecondaryEnvelopeForm";
import ManualTriggerForm from "./ManualTriggerForm";
import * as actions from "../../store/actions/index";

import { Collapse, message, Breadcrumb } from "antd";

import "./style.css";

const { Panel } = Collapse;

class SecondaryEnvelope extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hmgData: [],
      projectData: [],
      hotelData: [],
    };

    this.resetData = this.resetData.bind(this);
  }

  async fetchData(force) {
    // let promises = [];
    // promises.push(this.props.hotelGet());
    // promises.push(this.props.hmgGet());
    // promises.push(this.props.hmgMainGet());
    // promises.push(this.props.indexesGet());
    // await Promise.all(promises);

    if (force || !this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
    if (force || !this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (force || !this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    // if (!this.props.api.indexesGetData) {
    //     await this.props.indexesGet();
    // }
  }

  async componentDidMount() {
    this.fetchData(false);
  }

  resetData() {
    this.fetchData(true);
  }

  render() {
    return (
      <div>
        {/* <div className="container_aa">
                    <h3>Secondary Envelope</h3>
                    <Breadcrumb
                    routes={[
                        { path: "/", breadcrumbName: "Dashboard" },
                        { path: "/secondary-envelope", breadcrumbName: "Secondary Envelope" }
                    ]}
                    />
                </div> */}
        <div className="container_ab">
          {/* Secondary envelope form */}
          <div className="container_style_2">
            <Collapse defaultActiveKey={["sec_env_panel_1"]} expandIconPosition="end">
              <Panel
                header="Secondary Envelope"
                key="sec_env_panel_1"
                arrow="right"
              >
                <div className="sec_env_form_1">
                  {this.props.api.hotelGetData &&
                  this.props.api.hmgGetData &&
                  this.props.api.hmgMainGetData ? (
                    <SecondaryEnvelopeForm
                      hmgData={this.props.api.hmgMainGetData.data}
                      projectData={this.props.api.hmgGetData.data}
                      hotelData={this.props.api.hotelGetData.data}
                      // indexes={this.props.api.indexesGetData}
                      resetData={this.resetData}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>
          </div>

          {/* Manual trigger form */}
          <div className="container_style_2">
            <Collapse>
              <Panel
                header="Manual Trigger"
                key="sec_env_panel_2"
                arrow="right"
              >
                <div className="sec_env_form_2">
                  {this.props.api.hotelGetData &&
                  this.props.api.hmgGetData &&
                  this.props.api.hmgMainGetData ? (
                    <ManualTriggerForm
                      hmgData={this.props.api.hmgMainGetData.data}
                      projectData={this.props.api.hmgGetData.data}
                      hotelData={this.props.api.hotelGetData.data}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hotelGet: () => dispatch(actions.hotelGet()),
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  indexesGet: () => dispatch(actions.indexesGet()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryEnvelope);
